import lokalizacja from '@components/search/inputs/lokalizacjaZasieg'
import rodzajUslugi from '@components/search/inputs/rodzajUslugi'
import rodzajSerwisu from '@components/search/inputs/rodzajSerwisu'

const fakturaVAT = { type: 'multi-checkbox', options: ['Faktura VAT'], names: ['faktura-vat']}

const serviceFormInputsMobile = [
    rodzajUslugi,
    lokalizacja,
    rodzajSerwisu,
    fakturaVAT,
    { type: 'blank' },
    { type: 'blank' },
]

const serviceFormInputs = [
    rodzajUslugi,
    rodzajSerwisu,
    lokalizacja,
    { type: 'blank' },
    { type: 'blank' },
    fakturaVAT,
]

export {
    serviceFormInputsMobile,
    serviceFormInputs,
}